import { PaymentType } from "./enums";

export const accountsBalancesFields = [
  {
    currency: ["currency_id", "precision"],
  },
  "free_balance",
  "wallet_id",
];

export const userFields = ["user_id", "limit_group_id", "mfa_status"];

export const paymentsLimitsFields = ["deposit_min_amount", "withdrawal_min_amount", "currency_id"];

// Per-period used/limit/remaining for `calculate_payments_limits`.
// NOTE: deliberately omits `currency_id` on the period blocks — that field
// only exists on the LimitsStatusPeriods type from vakotrade 4.35; older
// client deployments lack it and would reject the whole query (blanking the
// widget). All values come back in notion_currency, so it isn't needed anyway.
const limitsStatusPeriodFields = () => [
  { daily: ["limit", "filled", "remaining"] },
  { weekly: ["limit", "filled", "remaining"] },
  { monthly: ["limit", "filled", "remaining"] },
];

export const calculatedPaymentsLimitsFields = (type: PaymentType) => {
  const fields: object[] = [{ payments: limitsStatusPeriodFields() }];
  // The backend 500s on `aggregated` for deposits — request it only for withdrawal.
  if (type === PaymentType.Withdrawal) {
    fields.push({ aggregated: limitsStatusPeriodFields() });
  }
  return fields;
};

export const createWithdrawalFiatFields = ["payment_id"];

export const paymentsRoutesFields = [
  "verification_type",
  "psp_service_id",
  "currency_id",
  {
    currency: ["currency_id", "precision"],
  },
  "meta",
];
